import { request, makeCancelable } from "../../utils/promises/library";
import { DEFAULT_SERVER_TIME, ELECTION_API_URL } from "./constants";
import { createElection, generateElectionData } from "./record";
import log from "../../utils/logger/library";

export const getElection = (province) => {
    const electionUrl = `${ELECTION_API_URL}/${province}/current_toplevel`;
    return request(electionUrl)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error(`${response.status}: ${response.statusText}`);
        })
        .then((json) => createElection(json));
};

export const setElectionState = (serverTime) => {
    return (province, setElection) => {
        const { promise, cancel } = makeCancelable(getElection(province));
        return {
            promise: promise
                .then((elec) => {
                    if (elec.serverTime > serverTime) {
                        setElection(elec);
                        serverTime = elec.serverTime;
                    }
                    return Promise.resolve(elec.live);
                })
                .catch((error) => {
                    serverTime = DEFAULT_SERVER_TIME;
                    log.error(
                        `(setElectionState) error setting election state for ${province}`,
                        error
                    );
                    setElection(generateElectionData());
                    return Promise.resolve(true);
                }),
            cancel,
        };
    };
};

export const pollElectionState = (interval, province, setElection) => {
    let cancel;
    let id;
    const sss = setElectionState(DEFAULT_SERVER_TIME);
    const req = () => {
        const promise = sss(province, setElection);
        cancel = promise.cancel;
        const rerun = () => {
            id = setTimeout(req, interval);
        };
        promise.promise.then((isLive) => {
            if (isLive) {
                rerun();
            }
        });
        promise.promise.catch(rerun);
    };
    req();
    return () => {
        cancel();
        clearInterval(id);
    };
};
